





























































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../requester';

import { TokenSenha } from '../../../back/src/entity/TokenSenha';
import { RedefinirSenhaFormData } from '../../../back/src/types';

import Carregando from '../components/Carregando.vue';
import EsqueciMinhaSenhaModal from '../components/EsqueciMinhaSenhaModal.vue';

export default Vue.extend({
  name: 'RedefinirSenha',
  components: {
    Carregando,
    EsqueciMinhaSenhaModal,
  },
  data() {
    return {
      loading: {
        form: true,
        submit: false,
      },
      error: [''],
      tokenSenha: {} as TokenSenha,
      form: {
        senha: '',
        senhaConfirmacao: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  async mounted() {
    this.loading.form = true;
    try {
      const response = await Requester.tokenSenha.tokenSenha(this.token);
      this.error = response.errors;
      this.tokenSenha = response.data;
    } catch (err) {
      this.error = [err.toString()];
      this.$root.$emit('requestError', err);
    } finally {
      this.loading.form = false;
    }
  },
  computed: {
    token(): string {
      return this.$route.query.token as string;
    },
    rulesSenhaConfirmacao() {
      return [
        () => (this.form.senha === this.form.senhaConfirmacao) || 'Confirmação deve ser igual à senha',
      ];
    },
    formRedefinirSenha(): Vue & { validate: () => boolean } {
      return this.$refs.formRedefinirSenha as Vue & { validate: () => boolean };
    },
  },
  methods: {
    touchSenhaConfirmacao() {
      if (this.form.senhaConfirmacao !== '') {
        this.formRedefinirSenha.validate();
      }
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm(): Promise<void> {
      this.loading.submit = true;
      if (!this.formRedefinirSenha.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: RedefinirSenhaFormData = {
        senha: this.form.senha,
        token: this.tokenSenha.token || '',
      };
      try {
        const response = await Requester.usuario.redefinirSenha(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Sua senha foi redefinida com sucesso!',
          });
          this.$store.dispatch('login', response.data);
          this.$router.push({ name: 'Home' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
